import styled, { css } from 'styled-components'
import { LinkReset } from './resets'
import {
  BodyLargeLink,
  BodyLink,
  BodySmallLink,
  SecondaryLink as BodySecondaryLink,
} from './typography'

const PrimaryLinkStates = css`
  &:visited {
    color: ${({ theme }) => theme.Colors.visitedLinkColor};
  }
  &:hover {
    color: ${({ theme }) => theme.Colors.hoverLinkColor};
    text-decoration: underline;
  }
  &:active {
    color: ${({ theme }) => theme.Colors.activeLinkColor};
    text-decoration: underline;
  }
`

export const Link = css`
  ${LinkReset};

  &,
  &:link {
    ${BodyLink};
    cursor: pointer;
  }

  ${PrimaryLinkStates};
`

export const LargeLink = css`
  ${LinkReset};

  &,
  &:link {
    ${BodyLargeLink};
    cursor: pointer;
  }

  ${PrimaryLinkStates};
`

export const SmallLink = css`
  ${LinkReset};

  &,
  &:link {
    ${BodySmallLink};
    cursor: pointer;
  }

  ${PrimaryLinkStates};
`

const SecondaryLinkStates = css`
  &:visited {
    color: ${({ theme }) => theme.Colors.visitedSecondaryLinkColor};
  }
  &:hover {
    color: ${({ theme }) => theme.Colors.hoverSecondaryLinkColor};
    text-decoration: underline;
  }
  &:active {
    color: ${({ theme }) => theme.Colors.activeSecondaryLinkColor};
    text-decoration: underline;
  }
`

export const SecondaryLink = css`
  ${LinkReset};

  &,
  &:link {
    ${BodySecondaryLink};
    cursor: pointer;
  }

  ${SecondaryLinkStates};
`

export const LinkContainer = styled.a`
  ${LinkReset};
`
